import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { RestResponse, RestService } from '@tdwb/core';
import { RecentSearchItem, SearchResult } from './site-wide-search.domain';

@Injectable()
export class SiteWideSearchRestService {
  constructor(private restService: RestService) {
  }

  search(searchTerm: string): Observable<SearchResult> {
    const params = {
      pathVariables: {
        searchTerm
      }
    };
    return this.restService.getResource('search.site-wide-search').get(params);
  }

  getRecentSearches(): Observable<Array<RecentSearchItem>> {
    return this.restService.getResource('recent-searches.list')
      .get<Array<RecentSearchItem>>()
      .pipe(
        map((response: Array<RecentSearchItem>): Array<RecentSearchItem> => {
          if (response !== undefined) {
            const recentSearches = response.sort(this.compare);
            return recentSearches;
          }
        })
      );
  }

  setRecentSearch(searchText: string): Observable<RestResponse<unknown>> {
    return this.restService.getResource('recent-searches.update').post({ searchText });
  }

  setRecentSymbolSearch(symbolSearchItem: RecentSearchItem): Observable<RestResponse<unknown>> {
    const params: RecentSearchItem = {
      searchText: symbolSearchItem.searchText,
      market: symbolSearchItem.market,
      symbolType: symbolSearchItem.symbolType
    };
    return this.restService.getResource('recent-searches.update').post(params);
  }

  deleteRecentSearch(recentSearchList: Array<RecentSearchItem>): Observable<RestResponse<unknown>> {
    return this.restService.getResource('recent-searches.remove-requests').post(recentSearchList);
  }

  private compare(a: RecentSearchItem, b: RecentSearchItem): number {
    if (a.priority < b.priority) {
      return -1;
    }
    if (a.priority > b.priority) {
      return 1;
    }
    return 0;
  }
}
